import { NgModule } from '@angular/core';
import { SabreSeatMapLibComponent } from './sabre-seat-map-lib.component';

@NgModule({
  declarations: [SabreSeatMapLibComponent],
  imports: [
  ],
  exports: [SabreSeatMapLibComponent]
})
export class SabreSeatMapLibModule { }
